<template>
    <div class='cashier-config' v-loading="isLoading">
        <p class="title">收款设置</p>
        <div class="receive-config common-config-style">
            <div class="receive-config-first fx-v-center">
                <span class="des color-999">订单总额精度</span>
                <div class="target fx-v-center">
                    <el-radio v-model="orderPrecision"
                        :label="1"
                        @change="precisionChange">精确到分(0.00)</el-radio>
                    <el-radio v-model="orderPrecision"
                        :label="2"
                        @change="precisionChange">精确到角(0.0)</el-radio>
                    <el-radio v-model="orderPrecision"
                        :label="3"
                        @change="precisionChange">精确到元(0)</el-radio>
                </div>
            </div>
            <div class="receive-config-second fx mt-24">
                <span class="des color-999">精度处理方式</span>
                <div class="target">
                    <el-radio v-model="roundMethod"
                        class="mb-12"
                        :label="1"
                        @change="roundMethodChange">四舍五入<span class="fs-12">（如：9.13元，精确到角后为9.1元；9.15元，精确到角后为9.2元）</span></el-radio>
                    <el-radio v-model="roundMethod"
                        class="mb-12"
                        :label="2"
                        @change="roundMethodChange">进一法<span class="fs-12">（如：9.13元，精确到角后为9.2元）</span></el-radio>
                    <el-radio v-model="roundMethod"
                        :label="3"
                        @change="roundMethodChange">去尾法<span class="fs-12">（如：9.13元，精确到角后为9.1元）</span></el-radio>
                </div>
            </div>
        </div>
        <p class="title">支付方式设置</p>
        <div class="common-config-style pay-setting fx-v-center fx-h-between">
            <div class="pay-setting__left">
                <span class="des fs-14 color-999 ">已开启</span>
                <span class="text-popper" v-textPopper>{{ paySettingText }}</span>
            </div>
            <div class="pay-setting__right">
                <button class="text-btn" @click="isShowPaySetting = true">编辑</button>
            </div>
        </div>
        <div class="fx-v-center mb-12 mt-20">
            <p class="title mb-0 mt-0">收银设备</p>
            <div>
                <span style="margin: 0 4px 0 20px">收银台位：{{ cashierSeat }}台</span>
                <el-tooltip effect="dark"
                    placement="top-end">
                    <div slot="content" style="line-height: 18px">
                        <p>1.收银台位：表示可同时收银的设备数。</p>
                        <p>2.默认为一台，表示本店最多可在1台收银机上收银。</p>
                        <p>3.增加收银台位需额外购买</p>
                    </div>
                    <i class="question-icon"/>
                </el-tooltip>
            </div>
            <button class="text-btn pl-0 pr-0 ml-12"
                @click="addCashier">添加</button>
        </div>
        <div class="cashier-list">
            <el-table style="width: 100%"
                :data="cashierList"
                :empty-text="isLoading ? ' ' : '暂无数据'">
                <el-table-column
                    type="index"
                    label="#"
                    width="50">
                </el-table-column>
                <el-table-column
                    label="设备号"
                    min-width="150">
                    <template v-slot="{ row }">
                        <p>{{ row.cashier_sn || '-' }}</p>
                    </template>
                </el-table-column>
                <el-table-column
                    label="当前状态"
                    min-width="350">
                    <template v-slot="{ row }">
                        <div v-if="row.occupier_staff != null && row.occupier_staff.user"
                            class="fx-v-center">
                            <span>在线</span>
                            &nbsp;|&nbsp;
                            <span>收银员：</span>
                            <user-info :userInfo="get(row, 'occupier_staff.user') || {}"
                                :maxWidth="'calc(100% - 100px)'"/>
                        </div>
                        <p v-else>离线</p>
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    width="80">
                    <template v-slot="{ row }">
                        <button v-if="row.occupier_staff != null && row.occupier_staff.user"
                            class="text-btn pl-0"
                            @click="makeStaffOffline(row)">下线</button>
                    </template>
                </el-table-column>
                <p v-if="cashierList.length > 0" slot="append" style="text-align: center; padding: 30px 0">没有更多了</p>
            </el-table>
        </div>
        <!-- 副屏公告 -->
        <p class="title">副屏公告</p>
        <div class="common-config-style notice-wrapper">
            <div class="notice-img-wrapper fx-v-center">
                <span class="des color-999">图片公告（限5张）</span>
                <div class="img-list fx-v-center">
                    <div v-for="(img) in imgList"
                        class="img-wrapper"
                        :key="img.id">
                        <el-image style="width: 100%; height: 100%"
                            fit="cover"
                            :src="getQiniuImgUrl(img.qiniu_key, 800)"
                            :preview-src-list="img.previewSrcList"/>
                        <img class="icondelete"
                            :src="deleteIcon"
                            @click.stop="noticeClose(0, img.id, img.notice_source)"/>
                    </div>
                </div>
                <qiniu-upload v-if="imgList.length < 5"
                    list-type="picture-card"
                    :imgLimit="300"
                    :useDefault="false"
                    @upload-success="uploadSuccess(0, $event)">
                    <i slot="default" class="el-icon-plus"/>
                </qiniu-upload>
            </div>
            <!-- <div class="notice-video-wrapper fx-v-center">
                <span class="des color-999">视频公告</span>
                <div class="video-list fx-v-center">
                    <div v-for="(vi) in videoList"
                        class="video-wrapper"
                        :key="vi.id"
                        @click="vi.isShow = true">
                        <video class="video-wrapper__model" :src="qiniuImageURLPrefix + vi.qiniu_key" />
                        <img class="icondelete"
                            :src="deleteIcon"
                            @click.stop="noticeClose(1, vi.id)"/>
                        <video-player
                            :showVideoPlayer="vi.isShow"
                            :videoSrc="qiniuImageURLPrefix + vi.qiniu_key"
                            @close-video-player="vi.isShow = false" />
                    </div>
                </div>
                <qiniu-upload v-if="isShowVideoQiniu"
                    class="mr-12"
                    list-type="picture-card"
                    :useDefault="false"
                    :isVideo="true"
                    @upload-success="uploadSuccess(1, $event)">
                    <i slot="default" class="el-icon-plus"/>
                </qiniu-upload>
                <p class="fs-14 color-999" v-if="editionJudgeTool.isBiaoZhun">标准版暂不支持上传视频公告，请<span class="color-green">升级</span>为专业版/旗舰版</p>
                <p class="fs-14 color-999" v-if="editionJudgeTool.isZhuanYe">专业版支持上传一份视频公告，如需上传多份，请<span class="color-green">升级</span>为旗舰版</p>
                <p class="fs-14 color-999" v-if="editionJudgeTool.isQiJian">最多上传5个</p>
            </div> -->
            <div class="carousel-time-wrapper fx-v-center">
                <span class="des color-999">轮播时间</span>
                <div class="target fx-v-center fx-h-between">
                    <span>{{ noticeTimeInterval }}秒</span>
                    <button class="text-btn"
                        @click="editNoticeTimeInterval">编辑</button>
                </div>
            </div>
        </div>
        <!-- components -->
        <pay-setting :visible.sync="isShowPaySetting" @success="getPaySetting" />
    </div>
</template>

<script lang='tsx'>
import { createComponent, ref, onBeforeMount, computed, Ref } from '@vue/composition-api'
import QuestionIcon from '@/components/question_icon/question_icon.vue'
import VideoPlayer from '@/components/video/video-player.vue'
import PaySetting from '../components/pay_setting.vue'
import { openMessage, openWarning } from '../../../utils/system'
import $fetch from '../../../api'
import clone from 'lodash/cloneDeep'
import get from 'lodash/get'
import { fixNum, queryString } from '../../../utils/index'
import QiniuUpload from '@/components/qiniu_upload/qiniu_upload.vue'
import { getQiniuImgUrl, qiniuImageURLPrefix } from '@/assets/ts/qiniu'
import { mapState } from 'vuex'
import domain from '@/config/domain'
import { editionJudge } from '../../../utils/editionJudge'
// @ts-ignore
import deleteIcon from './images/delete.svg'

export default createComponent({
    computed: {
        ...mapState({
            shopInfo: (state: any) => state.shop.shopInfo,
        })
    },
    setup: (props, ctx) => {
        const orderPrecision = ref(1)
        const roundMethod = ref(1)
        const noticeTimeInterval = ref(3)   // 默认轮播三秒
        const cashierSeat = ref(0)
        const isLoading = ref(false)
        const isShowPaySetting = ref(false)
        const paySettingText = ref('')
        const cashierList = ref<any[]>([])
        const imgList = ref<any[]>([])
        const videoList = ref<any[]>([])

        const store = ctx.root.$store
        const shopInfo = store.state.shop.shopInfo
        const paymentType = {
            0: '现金',
            1: '条码收款',
            2: '个人支付宝',
            3: '个人微信',
            4: '银行卡'
        }

        let cashierInfo: {
            fee_code: number,
            price: string,
            status: number
        } = {
            fee_code: 1001,
            price: "0.0100",
            status: 0
        }

        const editionJudgeTool = computed(() => {
            return editionJudge
        })

        const isShowVideoQiniu = computed(() => {
            return editionJudge.isZhuanYe ? (
                videoList.value.length < 1
            ) : (
                editionJudge.isQiJian ? (
                    videoList.value.length < 5
                ) : false
            )
        })

        onBeforeMount(() => {
            isLoading.value = true
            Promise.all([
                getShopConfig(),
                getCashierSeatOccupation(),
                getCashierInfo(),
                getPaySetting(),
                getSecondaryScreenNotice()
            ]).then(() => isLoading.value = false)
        })

        async function getPaySetting() {
            try {
                const result = await $fetch.post({
                    url: '/shop/getshoppayment'
                })
                console.log('支付方式', result)
                paySettingText.value = result.paymentconfig.payment_list
                                        .map(n => paymentType[n])
                                        .concat(
                                            result.custom_payment_config
                                                .filter(item => item.status === 1)
                                                .map(item => item.name)
                                        )
                                        .join('、')
            } catch (e) {
                openMessage('error', e.message || '获取支付方式信息失败')
            }
        }

        async function getShopConfig() {
            try {
                const result = await $fetch.post({
                    url: '/shop/getshopconfig'
                })
                console.log('店铺设置信息', result)
                const {
                    precision,
                    rounding_method,
                    cashier_seat,
                    notice_time_interval
                } = result
                orderPrecision.value !== precision && (orderPrecision.value = precision)
                roundMethod.value !== rounding_method && (roundMethod.value = rounding_method)
                cashierSeat.value !== cashier_seat && (cashierSeat.value = cashier_seat)
                noticeTimeInterval.value !== rounding_method && (noticeTimeInterval.value = notice_time_interval || 3)
            } catch (e) {
                openMessage('error', e.message || '获取店铺设置信息失败')
            }
        }

        async function getCashierSeatOccupation() {
            try {
                const result = await $fetch.post({
                    url: '/shop/cashierseatoccupation'
                })
                console.log('收银台占用信息', clone(result))
                cashierList.value = result.data_list
            } catch (e) {
                openMessage('error', e.message || '获取收银台占用信息失败')
            }
        }

        async function makeStaffOffline(row: any) {
            try {
                if (row.cashier_sn === '') {
                    return openMessage('error', '缺少设备号，无法下线')
                }
                if (row.occupier_staff.id == null) {
                    return openMessage('error', '缺少员工id，无法下线')
                }
                const flag = await openWarning({
                    title: '系统提示',
                    type: 'danger',
                    render: (h) => (
                        <div style="line-height: 20px; text-align: center; font-size: 14px; color: #333">
                            <p style="">确定下线该设备吗？</p>
                            <div class="fx-v-center fx-h-center mt-10 color-666">
                                强制下线后&nbsp;
                                <user-info userInfo={ get(row, 'occupier_staff.user') || {} }
                                    maxWidth={ '160px' }/>&nbsp;
                                将会自动退出收银台
                            </div>
                        </div>
                    )
                }).then(() => true, () => false)
                if (flag) {
                    await $fetch.post({
                        url: '/ws/makestaffoffline',
                        params: {
                            staff_id: row.occupier_staff.id,
                            cashier_sn: row.cashier_sn
                        }
                    })
                    openMessage('success', '设备下线成功')
                    getCashierSeatOccupation()
                }
            } catch (e) {
                openMessage('error', e.message || '设备下线失败')
            }
        }

        async function addCashier() {
            const purchaseNum = ref(1)
            const purchaseMoney = ref<number>(cashierInfo.price)
            const isDisabled = computed(() => purchaseNum.value === 0) as Ref<boolean>
            const btnStyle = {
                'display': 'inline-flex',
                'justify-content': 'center',
                'align-items': 'center',
                'width': '14px',
                'height': '14px',
                'font-size': '12px',
                'font-weight': '600',
                'color': '#999',
                'border': '1px solid #999',
                'border-radius': '50%',
                'box-sizing': 'border-box',
                'cursor': 'pointer'
            }
            const flag = await openWarning({
                title: '订单确认',
                type: 'primary',
                confirmBtnText: '立即支付',
                isDisabled,
                render: (h) => (
                    <div style="font-size: 14px; color: #333; line-height: 20px">
                        <div class="fx-v-center mb-10">
                            <span class="align-r color-666"
                                style="display: inline-block; width: 70px">购买服务：</span>
                            <span class="fw-600">收银台位</span>
                        </div>
                        <div class="fx-v-center mb-10">
                            <span class="align-r color-666"
                                style="display: inline-block; width: 70px">有效期：</span>
                            <span class="fw-600">一年</span>
                        </div>
                        <div class="fx-v-center mb-10">
                            <span class="align-r color-666"
                                style="display: inline-block; width: 70px">单价：</span>
                            <span class="fw-600">￥{ fixNum(purchaseMoney.value) }/位</span>
                        </div>
                        <div class="fx-v-center mb-10">
                            <span class="align-r color-666"
                                style="display: inline-block; width: 70px">购买数量：</span>
                            <span style={ btnStyle }
                                onClick={ () => purchaseNum.value > 1 && purchaseNum.value-- }>-</span>
                            <span class="fs-16 fw-600 color-green align-c"
                                style="display: inline-block; min-width: 30px">{ purchaseNum.value }</span>
                            <span style={ btnStyle }
                                onClick={ () => purchaseNum.value++ }>+</span>
                        </div>
                        <div class="fx-v-center">
                            <span class="align-r color-666"
                                style="display: inline-block; width: 70px">订单总价：</span>
                            <span class="fs-16 fw-600"
                                style="color: #ff533a"><span class="fs-12">￥</span>{ fixNum(purchaseMoney.value * purchaseNum.value) }</span>
                        </div>
                    </div>
                )
            }).then(() => true, () => false)

            if (editionJudge.isSunmi) {
                // return openActivateCodeWithGetShopInfo()
                return openMessage('error', '请联系您的服务商进行购买，如有疑问请拨打400-6666-509')
            }

            if (flag) {
                const centerPayDomain = domain.center + '#/main/paymentCenter'
                const queryParams = queryString({
                    shop_id: shopInfo.id,
                    shop_type: 'new_ls',
                    fee_code: cashierInfo.fee_code,
                    count: purchaseNum.value,
                    shop_super_admin_passport_id: shopInfo.creator && shopInfo.creator.passport_id
                }, true)
                window.location.href = centerPayDomain + queryParams
            }
        }

        async function setCashierConfig(options: {
            precision?: number,
            rounding_method?: number,
            notice_time_interval?: number
        }) {
            try {
                await $fetch.post({
                    url: '/shop/updateshopconfig',
                    params: options
                })
                openMessage('success', '设置成功')
            } catch (e) {
                openMessage('error', e.message || '设置失败')
                getShopConfig()
            }
        }

        async function getCashierInfo() {
            try {
                const result = await $fetch.post({
                    url: '/valueaddedservices/cashierseatpayinfo'
                })
                console.log('收银台位信息', result)
                cashierInfo = result.fee_infos[0]
            } catch (e) {
                openMessage('error', e.message || '获取收银台位信息失败')
            }
        }

        async function getSecondaryScreenNotice() {
            try {
                const result = await $fetch.post({
                    url: '/shop/getsecondaryscreennotice'
                })
                console.log('副屏公告', result)
                imgList.value = result.image_notices.map((item, i) => {
                    const firstSlice = result.image_notices.slice(0, i)
                    const secondSlice = result.image_notices.slice(i)
                    const previewSrcList = secondSlice.concat(firstSlice).map(img => getQiniuImgUrl(img.qiniu_key, 800))
                    return {
                        ...item,
                        previewSrcList
                    }
                })
                videoList.value = result.video_notices.map(item => ({
                    ...item,
                    isShow: false,
                    img: ''
                }))
                console.log('imgList', imgList.value)
                console.log('videoList', videoList.value)
            } catch (e) {
                openMessage('error', e.message || '获取副屏公告失败')
            }
        }

        /**
         * @param notice_type   // 0是图片 1是视频
         * @param qiniu_key     // 七牛key
         */
        async function addSecondaryScreenNotice(notice_type: 0 | 1, qiniu_key: string) {
            try {
                await $fetch.post({
                    url: '/shop/addsecondaryscreennotice',
                    params: {
                        secondary_screen_notice_list: [{
                            notice_type,
                            qiniu_key
                        }]
                    }
                })
                getSecondaryScreenNotice()
            } catch (e) {
                openMessage('error', e.message || '添加副屏公告失败')
            }
        }

        async function deleteSecondaryScreenNotice(secondary_screen_notice_id: number) {
            try {
                await $fetch.post({
                    url: '/shop/deletesecondaryscreennotice',
                    params: {
                        secondary_screen_notice_id
                    }
                })
                getSecondaryScreenNotice()
                openMessage('success', '删除成功')
            } catch (e) {
                openMessage('error', e.message || '删除副屏公告失败')
            }
        }

        /**
         * @param type  0 图片  1 视频
         * @param id    图片或视频对应的id
         */
        async function noticeClose(type: 0 | 1, id: number, notice_source: number) {
            if (notice_source === 0) {
                openMessage('error', '总部公告不允许删除')
                return
            }
            const flag = await openWarning({
                title: '系统提示',
                type: 'danger',
                render() {
                    return (
                        <p class="pt-10 pb-10 fs-14 fw-500 align-c color-333"
                            style="line-height: 20px">确认删除该公告{ type === 0 ? '图片' : '视频' }吗？</p>
                    )
                },
                confirmBtnText: '确认',
                cancelBtnText: '取消'
            }).then(() => true, () => false)
            if (flag) {
                deleteSecondaryScreenNotice(id)
            }
        }

        async function editNoticeTimeInterval() {
            try {
                const createCommonElement = (h, n) => {
                    return n === curStep.value
                        ? {
                            style: {
                                color: '#009688',
                                fontWeight: '600'
                            },
                            label: h('span', (n >= 5 ? n : 3) + '秒')
                        } : {
                            label: h('span', (n >= 5 ? n : 3) + '秒')
                        }
                }
                const curStep = ref(noticeTimeInterval.value >= 5 ? noticeTimeInterval.value : 0)
                const showStep = computed(() => {
                    return curStep.value >= 5 ? curStep.value : 3
                })
                function change(val) {
                    curStep.value = val
                }
                const flag = await openWarning({
                    title: '轮播图播放时间间隔',
                    render(h) {
                        return (
                            <div class="color-333 fs-14 pl-9 pr-9">
                                <p>时间间隔：</p>
                                <p class="align-c" style="height: 64px; line-height: 64px">当前选择时间间隔为 <span class="fs-16 fw-600 color-green">{ showStep.value }s</span></p>
                                <el-slider value={ curStep.value }
                                    step={ 5 }
                                    min={ 0 }
                                    max={ 25 }
                                    show-stops={ true }
                                    show-tooltip={ false }
                                    marks={
                                        {
                                            0: createCommonElement(h, 0),
                                            5: createCommonElement(h, 5),
                                            10: createCommonElement(h, 10),
                                            15: createCommonElement(h, 15),
                                            20: createCommonElement(h, 20),
                                            25: createCommonElement(h, 25)
                                        }
                                    }
                                    onInput={ change } />
                                <div class="pb-8"/>
                            </div>
                        )
                    },
                    confirmBtnText: '确认',
                    cancelBtnText: '取消'
                }).then(() => true, () => false)
                if (flag) {
                    noticeTimeInterval.value = showStep.value
                    setCashierConfig({
                        notice_time_interval: showStep.value
                    })
                }
            } catch (e) {
                openMessage('error', e.message || '编辑失败')
            }
        }

        function precisionChange(newVal) {
            setCashierConfig({
                precision: newVal
            })
        }

        function roundMethodChange(newVal) {
            setCashierConfig({
                rounding_method: newVal
            })
        }

        function uploadSuccess(
            type: 0 | 1,
            imgParams: {
                imgSrc: string,
                key: string
            }
        ) {
            addSecondaryScreenNotice(type, imgParams.key)
        }

        return {
            // data
            isLoading,
            isShowPaySetting,
            orderPrecision,
            roundMethod,
            noticeTimeInterval,
            cashierSeat,
            cashierList,
            paySettingText,
            imgList,
            videoList,
            deleteIcon,
            qiniuImageURLPrefix,
            // computed
            editionJudgeTool,
            isShowVideoQiniu,
            // methods
            get,
            getQiniuImgUrl,
            addCashier,
            getPaySetting,
            makeStaffOffline,
            precisionChange,
            roundMethodChange,
            uploadSuccess,
            noticeClose,
            editNoticeTimeInterval
        }
    },
    components: {
        QuestionIcon,
        PaySetting,
        QiniuUpload,
        VideoPlayer
    }
})
</script>

<style lang="scss" scoped>
.cashier-config {
    font-size: 14px;
    color: #333;
    overflow-y: auto;

    > div:last-child {
        margin-bottom: 20px;
    }

    .title {
        position: relative;
        line-height: 20px;
        margin: 20px 0 12px;
        padding-left: 8px;
        font-weight: 600;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            width: 4px;
            height: 20px;
            background-color: #009688;
            border-radius: 2px;
        }
    }

    .des {
        flex: none;
        display: inline-block;
        width: 134px;
        line-height: 20px;
    }

    .receive-config {
        padding: 12px;
        border: 1px solid #ebebeb;
    }

    .common-config-style {
        padding: 12px;
        border: 1px solid #ebebeb;

        .des {
            flex: none;
            display: inline-block;
            width: 134px;
            line-height: 20px;
        }
    }

    .notice-wrapper {
        .notice-video-wrapper {
            padding: 20px 0;
        }

        .notice-img-wrapper,
        .notice-video-wrapper {

            .img-list,
            .video-list {
                height: 40px;

                .video-wrapper::after {
                    content: '';
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: 0;
                    bottom: 0;
                    margin: auto;
                    width: 20px;
                    height: 20px;
                    background: url('~@/assets/images/begin-play.svg') center / cover no-repeat;
                    z-index: 1;
                }

                .img-wrapper,
                .video-wrapper {
                    position: relative;
                    width: 40px;
                    height: 40px;
                    margin-right: 12px;
                    border: 1px solid #ddd;
                    border-radius: 4px;
                    cursor: pointer;

                    &::before {
                        content: '';
                        position: absolute;
                        left: 0;
                        top: 0;
                        right: 0;
                        bottom: 0;
                        background-color: rgba(0, 0, 0, .2);
                        border-radius: 4px;
                        z-index: 1;
                        opacity: 0;
                        transition: opacity .25s;
                        pointer-events: none;
                    }

                    &:hover::before,
                    &:hover::after,
                    &:hover > .icondelete {
                        opacity: 1;
                    }

                    ::v-deep .el-image,
                    .video-wrapper__model {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        border-radius: 4px;
                    }

                    .icondelete {
                        position: absolute;
                        right: -8px;
                        top: -8px;
                        width: 16px;
                        height: 16px;
                        font-size: 16px;
                        transition: opacity .25s;
                        border-radius: 50%;
                        opacity: 0;
                        z-index: 1;
                    }
                }
            }

            ::v-deep .el-upload--picture-card {
                display: inline-block;
                width: 40px;
                height: 40px;
                line-height: 40px;
                text-align: center;

                .el-icon-plus {
                    font-size: 20px;
                }
            }
        }

        .carousel-time-wrapper {
            height: 44px;
            line-height: 44px;

            .target {
                flex: 1;
            }
        }
    }

    .receive-config {
        &-second {
            ::v-deep .el-radio {
                display: block;
                margin-right: 0;
            }

            .fs-12 {
                color: #999;
            }
        }
    }

    .pay-setting {
        padding: 12px;
        border: 1px solid #ebebeb;

        &__left {
            flex: 1;

            .text-popper {
                width: auto;
                max-width: calc(100% - 160px)
            }
        }
    }

    .question-icon {
        line-height: 1;
        font-size: 14px;
        color: #fff;
        margin-left: 4px;

        &::before {
            content: '?';
            display: inline-block;
            width: 20px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            font-weight: normal;
            background: #d0d0d0;
            border-radius: 50%;
        }
    }
}

::v-deep .el-table thead{
    tr {
        th {
            background: #fff;
            border: none;
            border-top: 1px solid #ebebeb;
            border-bottom: 1px solid #ebebeb;

            .cell {
                color: #999;
                font-weight: 600;
            }
        }
    }
}
</style>
